const hostCommon = 'eventsgo/common/'
// 公共方法调用
export const FIND_PERSON = hostCommon + 'services/eventsgo/common/userInfoService/getPerson'
